import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import Newuploader from "lib/mixins/Newuploader";
export default {
  name: "oss-newthumbnail",
  mixins: [Newuploader],
  props: {
    format: {
      type: String,
      default: "image"
    },
    tip: {
      type: String
    },
    count: {
      type: Number,
      default: 1
    },
    minHeight: {
      type: Number,
      default: 0
    },
    minWidth: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      limit: 1,
      isNeedSave: 1,
      // 1 保存为封面、头像等不在课件中展示
      acceptExts: {
        image: ".jpg,.jpeg,.png",
        file: ".jpg,.jpeg,.png,.gif,.zip,.pdf"
      },
      acceptTypes: ["image/png", "image/jpeg"],
      hideUploader: false,
      multiple: false,
      docId: "",
      docUrl: ""
    };
  },
  watch: {//
  },
  created: function created() {
    if (this.count != 1) {
      this.limit = this.count;
      this.multiple = true;
    } else {
      this.limit = 2;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fileList = [];
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var that = this;

      if (this.format === "image") {
        var isPngJpg = this.acceptTypes.includes(file.type);

        if (!isPngJpg) {
          this.$message.info({
            title: file.name,
            message: "只能上传 PNG / JPG 格式的图片"
          });
          return false;
        }
      }

      var fileData = file; //读取图片数据

      return new Promise(function (resolve) {
        var reader = new FileReader();

        reader.onload = function (e) {
          var data = e.target.result; //加载图片获取图片真实宽度和高度

          var image = new Image();
          image.src = data;

          image.onload = function () {
            var width = image.width;
            var height = image.height;

            if (image.width > that.minWidth && image.height > that.minHeight) {
              if (that.count === 1) {
                var f = that.$refs.upload.uploadFiles;

                if (f.length > 1) {
                  var uf = f[0];
                  console.log(uf);
                  that.$refs.upload.handleRemove(uf); // this.fileList.shift();
                }
              }

              that.addFile(file).then(resolve); // reader.readAsDataURL(fileData);
              // return;
            } else {
              that.$message.warning("上传图片必须大于:" + that.minWidth + "*" + that.minHeight);
              that.files = [];
              return false;
            }
          }; // image.src= data;

        };

        reader.readAsDataURL(fileData);
      });
    },
    onExceed: function onExceed(files, fileList) {
      this.$message.warning("\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6, \u8D85\u51FA\u5355\u6B21\u6700\u5927\u4E0A\u4F20\u6587\u4EF6 ").concat(this.limit, " \u4E2A\u7684\u9650\u5236"));
    },
    onRemoveHandler: function onRemoveHandler() {
      if (this.onRemove) {
        this.onRemove();
      }
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
        this.$emit("update:docId", res.docId);
      }
    }
  }
};